/**
 * The one card at the top of Início in a browser while the person has no AI working for them yet
 * (docs/refactor/51, N1 and N4): the app is what runs the AI on their computer, so getting it is
 * the next step. Connecting an AI that already runs in an IDE, without the app, is the advanced way
 * and stays one link away. Not drawn in the desktop app, nor for somebody with no agent of their own.
 */

import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Download, MonitorDown } from 'lucide-react'
import { api } from '../lib/api'
import { isDesktop } from '../lib/desktop'
import { useI18n } from '../lib/i18n'
import { DOWNLOAD_URL } from '../lib/startPath'

export function GetTheApp() {
  const { t } = useI18n()
  const web = !isDesktop()
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: api.auth.me, staleTime: 5 * 60_000 })
  const own = web && Boolean(me?.developerId)
  const { data: keys } = useQuery({ queryKey: ['me', 'credentials'], queryFn: api.me.credentials, enabled: own, retry: false })
  const { data: machines } = useQuery({ queryKey: ['machines'], queryFn: api.promptQueue.machines, enabled: own, retry: false })
  // Unknown (still loading, refused): nothing, rather than telling someone set up to set up.
  if (!own || keys === undefined || machines === undefined) return null
  if (machines.length > 0 || keys.some((k) => !k.revokedAt && Boolean(k.lastUsedAt))) return null

  return (
    <section className="panel get-app" aria-labelledby="get-app-title">
      <MonitorDown size={28} className="get-app__icon" aria-hidden />
      <div className="stack stack--tight get-app__text">
        <h2 id="get-app-title" className="get-app__title">{t('home.getApp.title')}</h2>
        <p className="small muted" style={{ margin: 0 }}>{t('home.getApp.body')}</p>
        <div className="row row--tight row--wrap">
          <a className="btn btn--primary" href={DOWNLOAD_URL} target="_blank" rel="noreferrer">
            <Download size={14} /> {t('home.getApp.download')}
          </a>
          <Link className="btn btn--ghost btn--sm" to="/agents/connect?tab=ide">{t('home.getApp.ide')}</Link>
        </div>
      </div>
    </section>
  )
}
